
export class UpdateDanceSchoolLocationVisibilityRequestDto {
  isPublic: boolean;
}
